import React from 'react'

export const NotFound = () => {
    return (
        <div>
            Sivua ei löydy
        </div>
    )
}